export default function RDocumentation() {
  return (
    <div>
      <p>
        The disgenet2r package contains a set of functions to retrieve, visualize and expand DISGENET data.{' '}
        {`\n`}
        You can consult the documentation for the disgenet2r package in{' '}
        <a href="https://medbio.gitlab.io/disgenet2r/" target="_blank" rel="noreferrer">
          this page
        </a>
        .
      </p>
    </div>
  );
}
